import { flattenColorPalette } from '../utils/flatten-color-palette';

import type { PluginCreator } from 'tailwindcss/types/config';

/**
 * Just export your **dynamic** utilities as instances of Tailwind's PluginCreator from this file, and you're good to go.
 *
 * Review the Tailwind documentation to learn how to write dynamic utilities in JS:
 * https://tailwindcss.com/docs/plugins#dynamic-utilities
 */

// export const example: PluginCreator = ({matchUtilities, theme}) => {
//   matchUtilities(
//     {
//       tab: (value) => ({
//         tabSize: value
//       }),
//     },
//     {values: theme('spacing')}
//   );
// };

export const overlay: PluginCreator = ({matchUtilities, theme}) => {
  matchUtilities(
    {
      overlay: (value) => ({
        position: 'relative',
        color: 'inherit',
        '&::after': {
          position: 'absolute',
          display: 'block',
          inset: '0',
          content: '" "',
          pointerEvents: 'none',
          backgroundColor: value,
        }
      }),
    },
    {values: flattenColorPalette(theme('colors'))}
  );
};

export const overlayBlackGradient: PluginCreator = ({matchUtilities, theme: _theme}) => {
  matchUtilities(
    {
      'overlay-black-gradient': (value) => ({
        position: 'relative',
        color: 'inherit',
        '&::after': {
          position: 'absolute',
          display: 'block',
          inset: '0',
          content: '" "',
          pointerEvents: 'none',
          background: `linear-gradient(rgba(7, 21, 47, 0) 0%, rgba(7, 21, 47, ${parseInt(value, 10) / 100}) 100%)`,
        }
      }),
    },
    {values: {
      50: '50',
      80: '80',
    }}
  );
};

export const UniversalCarouselStageGap: PluginCreator = ({matchUtilities, theme}) => {
  matchUtilities(
    {
      'carousel-stage-gap': (value) => ({
        '--compass-uc-gap': value,
        gap: 'var(--compass-uc-gap)',
      }),
    },
    {values: theme('spacing')}
  );
};

export const UniversalCarouselItemWidth: PluginCreator = ({matchUtilities, theme}) => {
  const getUncalculated = (value: string) => ({
    width: value,
  });

  matchUtilities(
    {
      'carousel-item-w': (value) => {
        value = (value ?? '').toString();

        if (!value.includes('%')) {
          return getUncalculated(value);
        }

        const percentage = parseInt(value.split('%').join(''), 10);
        const segmentSize = Math.round(100 / percentage);

        if (segmentSize === 1) {
          return getUncalculated(value);
        }

        return {
          width: `calc(${value} - (var(--compass-uc-gap, 0px) / ${segmentSize} * ${segmentSize - 1}))`,
        };
      },
    },
    {values: theme('width')}
  );
};
